var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexconEnergy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6273_41305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hexicon-bg",
    d: "M43 12.3341V37.0102L21.504 49.3443L0 37.0102V12.3341L21.496 0L42.992 12.3341H43Z",
    fill: "#4CC223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33 38.9286C20.7642 39.0644 21.2628 38.8246 21.4317 38.369C23.1527 34.9398 24.8737 31.5105 26.5946 28.0893C26.5625 28.0893 26.5303 28.0893 26.4901 28.0893C26.5785 28.0333 26.6509 27.9534 26.7072 27.8575C27.4149 26.4186 28.1226 24.9878 28.8303 23.5489C29.0072 23.1812 28.7418 22.7416 28.3236 22.7336L22.3646 22.6217C22.7345 19.2964 23.1044 15.963 23.4663 12.6377C23.5226 12.2061 23.2572 11.7984 22.8632 11.6785C22.4289 11.5426 21.9303 11.7824 21.7614 12.238C19.9842 15.7712 18.2069 19.3044 16.4377 22.8375C15.6818 24.3563 14.9258 25.8671 14.1619 27.3858C13.9688 27.7615 14.2503 28.2092 14.6765 28.2012C16.7192 28.2012 18.7618 28.1932 20.8045 28.1852C20.4426 31.4466 20.0887 34.708 19.7268 37.9693C19.6706 38.401 19.9359 38.8087 20.33 38.9286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6273_41305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 49.3523,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexconEnergy);
export default __webpack_public_path__ + "static/media/hexcon-energy.ddfc34ecc4f41fffc27a27ebbcc6d47c.svg";
export { ForwardRef as ReactComponent };